import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Box, Grid, Button, Tooltip, Typography, Divider } from '@material-ui/core';
import { useFormRepresentantesEdicaoValidation } from './form-representante-edicao-validation';
import { CircularLoading } from 'views/components/utils/circular-loading/circular-loading';
import {
    TextFieldSaurus,

} from 'views/components/controles/inputs';
import {
    DefaultFormProps,
    DefaultFormRefs,
} from 'views/components/form/utils/form-default-props';
import { useThemeQueries, makeUtilClasses } from 'views';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { picker } from 'utils/picker';
import { EnumTipoPessoas } from 'model/enums/enum-tipo-pessoas';
import { SelectSaurus } from 'views/components/controles/selects/select-saurus/select-saurus';
import { PessoaPostModel } from 'model/api/gestao/pessoa/pessoa-post-model';
import { validarCPFCNPJ } from 'utils/cpfcnpj-validate';
import { useSessaoAtual, useToastSaurus } from 'services/app';
import { ProcurarIcon } from 'views/components/icons';
import { isCnpj } from 'utils/cpfcnpj-format';
import { useStyles } from '../gerente-edicao/form-gerente-edicao-styles'
import { SituacaoPessoaMock } from 'data/mocks/pessoa-situacao-mock';
import { EnumSituacaoPessoa } from 'model/enums/enum-situacao-pessoa';
import { AutocompleteRevendas } from 'views/components/controles/autocompletes/autocomplete-revendas/autocomplete-revendas';
import { AutocompleteClassificacoes } from 'views/components/controles/autocompletes/autocomplete-classificacao/autocomplete-classificacao';

interface FormPessoaEdicaoProps extends DefaultFormProps<PessoaPostModel> {
    consultarCnpj?: () => void;
    configuracoes?: boolean;
    block?: boolean;
}

export const FormRepresentanteEdicao = forwardRef<
    DefaultFormRefs<PessoaPostModel>,
    FormPessoaEdicaoProps
>(
    (
        { loading, onSubmit, configuracoes, block, ...props }: FormPessoaEdicaoProps,
        ref,
    ) => {
        const { isMobile } = useThemeQueries();
        const utilClasses = makeUtilClasses();
        const classes = useStyles()
        const refInputNome = useRef<HTMLInputElement>(null);
        const { FormRepresentanteValidationYup } = useFormRepresentantesEdicaoValidation()
        const { showToast } = useToastSaurus()
        const { tipoUsuario } = useSessaoAtual()
        const { theme } = useThemeQueries()

        // const { getPessoa, carregando: carregandoGet } = useGetPessoa()

        const [model, setModel] = useState<PessoaPostModel>(new PessoaPostModel())
        // const [arrayRevenda, setArrayRevenda] = useState<KeyValueModel[]>([])

        // const getPessoaWrapper = useCallback(async () => {
        //   const query = `tipoPessoa=${EnumTipoPessoas.Revendedor}&pageSize=0`
        //   const res = await getPessoa(1, query)

        //   if (res.erro) throw res.erro

        //   const mock = res.resultado?.data.list.map(item => {
        //     return new KeyValueModel(item.id, item.nomeComercial)
        //   })

        //   setArrayRevenda(mock ?? [])
        // }, [getPessoa])

        // useEffect(() => {
        //   if (tipoFormPessoa === EnumTipoPessoas.Cliente && !tipoRevenda) {
        //     getPessoaWrapper()
        //   }
        // }, [getPessoaWrapper, tipoFormPessoa, tipoRevenda])

        const {
            handleSubmit,
            control,
            formState: { errors },
            reset,
            setValue,
            getValues,
        } = useForm<PessoaPostModel>({
            defaultValues: { ...model },
            resolver: yupResolver(FormRepresentanteValidationYup),
            criteriaMode: 'all',
            mode: 'onBlur' && 'onChange',
        });
        const submit = (values: PessoaPostModel) => {
            const pessoa = picker<PessoaPostModel>(values, new PessoaPostModel())
            if (!validarCPFCNPJ(pessoa.cpfCnpj)) {
                return showToast('error', 'CPF/CNPJ Inválido')
            }
            pessoa.melhorDia = null
            onSubmit(pessoa, model);
        };

        const carregando = loading

        useImperativeHandle(ref, () => ({
            submitForm: () => {
                handleSubmit(submit)();
            },
            resetForm: () => {
                reset();
                if (!isMobile) refInputNome.current?.focus();
            },
            fillForm: (values: PessoaPostModel) => {
                setModel(values)
                reset({ ...values })
                if (!isMobile) refInputNome.current?.focus();
            },
        }));

        return (
            <>
                <Box my={2}>
                    <div className={utilClasses.formContainer} style={{
                        position: 'relative'
                    }}>
                        {carregando && props.showLoading ? (
                            <div className={utilClasses.controlLoading}>
                                <CircularLoading tipo="FULLSIZED" />
                            </div>
                        ) : null}

                        <form
                            onSubmit={handleSubmit(submit)}
                            className={carregando ? utilClasses.controlLoading : ''}
                            style={{ padding: !isMobile ? '10px' : '0' }}
                        >
                            <Grid container spacing={2} justifyContent="center">
                                <Grid item xs={12}>
                                    <div
                                        style={{
                                            display: 'flex',
                                        }}
                                    >
                                        <Controller
                                            name="cpfCnpj"
                                            control={control}
                                            render={({ field }) => (
                                                <Box pr={isCnpj(getValues('cpfCnpj')) ? 1 : 0} width="100%">
                                                    <TextFieldSaurus
                                                        disabled={(tipoUsuario() === EnumTipoPessoas.Representante) || loading}
                                                        readOnly={block}
                                                        allowSubmit={false}
                                                        tipo="CNPJ_CPF"
                                                        label="CPF/CNPJ"
                                                        fullWidth
                                                        autoComplete={'off'}
                                                        helperText={
                                                            errors.cpfCnpj
                                                                ? errors.cpfCnpj.message
                                                                : undefined
                                                        }
                                                        error={Boolean(errors.cpfCnpj && errors.cpfCnpj.message)}
                                                        {...field}
                                                    />
                                                </Box>
                                            )}
                                        />
                                        {isCnpj(getValues('cpfCnpj')) ? (
                                            <Tooltip title="Consultar Cnpj">
                                                <Button
                                                    variant="contained"
                                                    color='primary'
                                                    className={classes.buttonConsulta}
                                                    onClick={() => props.consultarCnpj && props.consultarCnpj()}
                                                >
                                                    <ProcurarIcon tipo="BUTTON_PRIMARY" />
                                                </Button>
                                            </Tooltip>
                                        ) : null}
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <Controller
                                        name="nomeComercial"
                                        control={control}
                                        render={({ field }) => (
                                            <TextFieldSaurus
                                                disabled={loading}
                                                allowSubmit={false}
                                                readOnly={block}
                                                inputRef={refInputNome}
                                                label="Nome"
                                                fullWidth
                                                autoComplete={'off'}
                                                helperText={
                                                    errors.nomeComercial
                                                        ? errors.nomeComercial.message
                                                        : undefined
                                                }
                                                error={Boolean(errors.nomeComercial && errors.nomeComercial.message)}
                                                {...field}
                                            />
                                        )}
                                    />
                                </Grid>
                                {!configuracoes && <Grid item xs={12}>
                                    <Controller
                                        name="classificacaoId"
                                        control={control}
                                        render={({ field }) => (
                                            <AutocompleteClassificacoes
                                                label='Classificação'
                                                value={getValues('classificacaoId') || undefined}
                                                defaultValue={model.classificacaoId || undefined}
                                                defaultName={model.classificacaoAbreviacao}
                                                fetchOnLoad
                                                onChange={(e: any) => {
                                                    setValue('classificacaoId', e.value.id)
                                                }}
                                                helperText={
                                                    errors.classificacaoId
                                                        ? errors.classificacaoId.message
                                                        : undefined
                                                }
                                                error={Boolean(errors.classificacaoId && errors.classificacaoId.message)}
                                            />
                                        )}
                                    />
                                </Grid>}
                                {(!configuracoes && tipoUsuario() === EnumTipoPessoas.SoftwareHouse) && (
                                    <>
                                        <Grid item xs={12}>
                                            <Controller
                                                name="status"
                                                control={control}
                                                render={({ field }) => (
                                                    <SelectSaurus
                                                        disabled={loading || getValues('status') === EnumSituacaoPessoa.Inadimplente}
                                                        allowSubmit={false}
                                                        label="Situação"
                                                        fullWidth
                                                        conteudo={SituacaoPessoaMock}
                                                        autoComplete={'off'}
                                                        helperText={
                                                            errors.status
                                                                ? errors.status.message
                                                                : undefined
                                                        }
                                                        error={Boolean(errors.status && errors.status.message)}
                                                        {...field}
                                                        onChange={ev => {
                                                            const item = SituacaoPessoaMock
                                                                .filter(item => ev.target.value === item.Key)
                                                            setValue('status', item[0].Key)
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Controller
                                                name="revendaId"
                                                control={control}
                                                render={({ field }) => (
                                                    <AutocompleteRevendas
                                                        label='Revendedor'
                                                        value={getValues('revendaId') || undefined}
                                                        defaultValue={model.revendaId || undefined}
                                                        defaultName={model.revendaNome}
                                                        fetchOnLoad
                                                        onChange={(e: any) => {
                                                            setValue('revendaId', e.value.id)
                                                        }}
                                                        helperText={
                                                            errors.revendaId
                                                                ? errors.revendaId.message
                                                                : undefined
                                                        }
                                                        error={Boolean(errors.revendaId && errors.revendaId.message)}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </>
                                )}
                                {(!configuracoes) && <Grid item xs={12}>
                                    <Grid container spacing={2} className={classes.loginContainer}>
                                        <Grid item xs={12}>
                                            <Typography variant='h6' color='primary'>Login</Typography>
                                            <Divider style={{ background: theme.palette.divider, marginTop: 5 }} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Controller
                                                name="login"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextFieldSaurus
                                                        disabled={loading}
                                                        allowSubmit={false}
                                                        label="Usuário"
                                                        tipo="TEXTO"
                                                        fullWidth
                                                        autoComplete={'new-password'}
                                                        helperText={
                                                            errors.login
                                                                ? errors.login.message
                                                                : undefined
                                                        }
                                                        error={Boolean(errors.login && errors.login.message)}
                                                        {...field}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Controller
                                                name="senha"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextFieldSaurus
                                                        disabled={loading}
                                                        allowSubmit={false}
                                                        label="Senha"
                                                        tipo='PASSWORD'
                                                        fullWidth
                                                        autoComplete={'new-password'}
                                                        helperText={
                                                            errors.senha
                                                                ? errors.senha.message
                                                                : undefined
                                                        }
                                                        error={Boolean(errors.senha && errors.senha.message)}
                                                        {...field}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>}
                            </Grid>
                            <Button style={{ display: 'none' }} type="submit"></Button>
                        </form>
                    </div>
                </Box>
            </>
        );
    },
);